import React from 'react';
import { Button } from './Button';
interface IndividualProductCardProps {
  title: string;
  description: string;
  price: string;
  href: string;
  image?: string;
}
export function IndividualProductCard({
  title,
  description,
  price,
  href,
  image
}: IndividualProductCardProps) {
  return <div className="bg-brand-lightBlue rounded-2xl p-6 text-left flex flex-col" data-id="element-189">
      {image ? <div className="mb-4 flex justify-center" data-id="element-190">
          <img src={image} alt={title} className="h-48 w-auto object-contain" data-id="element-191" />
        </div> : <div className="text-4xl mb-3" data-id="element-192">📘</div>}
      <h3 className="text-lg font-bold text-brand-navy mb-3" data-id="element-193">{title}</h3>
      <p className="text-brand-navy text-sm mb-4 leading-relaxed flex-grow" data-id="element-194">
        {description}
      </p>
      <div className="text-2xl font-black text-brand-pink mb-4" data-id="element-195">{price}</div>
      <Button href={href} className="w-full text-base" data-id="element-196">
        👉 COMPRAR AHORA
      </Button>
    </div>;
}